// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Manrope-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./NotoSansArabic-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'MediumFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Manrope';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/font.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4DAAkD;EAClD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAqD;EACrD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAAwD;EACxD,kBAAkB;AACpB","sourcesContent":["@font-face {\r\n  font-family: 'MediumFont';\r\n  src: url('./Manrope-Medium.woff2') format('woff2');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Manrope';\r\n  src: url('./Manrope-Medium.woff2') format('truetype');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'arabic';\r\n  src: url('./NotoSansArabic-VariableFont_wdth\\,wght.ttf');\r\n  font-style: normal;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
